import {Component} from "../interface/component";
require('slick-carousel/slick/slick.min');

export class CarouselCaseStudiesComponent implements Component {
    private $root:JQuery;
    private $scrollNext: JQuery;
    private $scrollPrev: JQuery;
    private slick_active = false;
    private slick_init = false;
    private carouselItemsToShow:number = 4;

    constructor(elem:HTMLElement) {
        this.$root = $(elem);
    }

    init() {
        this.bindUI();
        if (this.slickNeedsActivating()) {
            this.activateSlick();
        }
        $(window).on("resize", this.resizeHandler);
    }

    private bindUI = () => {
        this.$scrollNext      = this.$root.parent().next().find('.js-case-study-carousel-scroll-right');
        this.$scrollPrev      = this.$root.parent().next().find('.js-case-study-carousel-scroll-left');
    };

    private initSlick = () => {
        console.log('test', this.$root.slick);
        if (undefined === this.$root.slick) {
            setTimeout(this.initSlick, 100);
        } else {
            if (this.$root.children().length <= this.carouselItemsToShow) {
                this.$root.addClass('static-function');
            }
            this.$root.slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 300,
                nextArrow: this.$scrollNext,
                prevArrow: this.$scrollPrev,
                slidesToShow: this.carouselItemsToShow,
                slidesToScroll: 1,
                cssEase: 'cubic-bezier(0.47, 0, 0.745, 0.715)',
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: 'unslick'
                    }
                ]
            });
            this.slick_init = true;
        }
    }

    private activateSlick = () => {
        this.slick_active = true;
        setTimeout(() => {
            if (!this.slick_init) {
                this.initSlick();
            } else {
                this.$root.slick('reinit');
            }
        }, 100);
    }

    private deactivateSlick = () => {
        this.slick_active = false;
        this.$root.slick('unslick');
    }

    private slickNeedsActivating = () => {
        return window.innerWidth >= 640;
    }

    private resizeHandler = (ev: Event) => {

        if (!this.slick_active && this.slickNeedsActivating()){
            this.activateSlick();
        } else {
            if (this.slick_active && !this.slickNeedsActivating()){
                this.deactivateSlick();
            }
        }
    }
}
